import {find} from 'lodash';
import MobileDetect from 'mobile-detect';
import * as React from 'react';
import {Outlet, useLocation, useNavigate} from 'react-router-dom';
import {Subject} from 'rxjs';
import screenOrientation from 'screen-orientation';
import {Pages} from '../../pages';
import {navigateTo, setNavigator} from '../../router';
import {BackgroundComponent} from '../libs/background.component';
import {NavigationComponent} from '../libs/navigation/navigation.component';
import './style.scss';
import {ModalComponent} from "../libs/modal/modal.component";
import {Translation} from "../../lang";

const leftArrow = '/assets/src/components/layouts/left-arrow.svg';
const rightArrow = '/assets/src/components/layouts/right-arrow.svg';
const logo: string = '/assets/src/components/libs/modal/logo.svg';

export class MainLayout extends React.Component<any, any> {
    private defaultColorMatrix = ['#3889ff', '#01eacc'];
    public md: MobileDetect = new MobileDetect(window.navigator.userAgent);
    public navigationStatus$ = (window as any).siteEventSubscribers.navigation.status;
    public routePathChange$ = new Subject();
    private hkModalRef: any;

    public state: any = {
        path: '',
        index: 0,
        colorMatrix: null,
        triangles: null,
        menuStatus: false,
        hivatalosKozlemenyModal: false
    };

    componentDidMount(): void {
        this.routePathChange$.subscribe((path: any) => this.handleRouteChange(path));
        this.navigationStatus$.subscribe((s: boolean) => this.setState({menuStatus: s}));

        const body = document.body;
        body.classList.remove('uninitialized');
        body.classList.add(`mobile-${this.md.mobile()}`);
        body.classList.add(`userAgent-${this.md.userAgent()}`);
        body.classList.add(`orientation-${screenOrientation().direction}`);
        body.classList.add(`orientation-version-${screenOrientation().version}`);
        this.routePathChange$.next(this.props.pathname);
    }

    handleRouteChange(path: string) {
        const page = find(Pages, (item: any) => {
            return item.path === path;
        });

        if (page) {
            this.setState({
                index: page.index,
                colorMatrix: page.colorMatrix,
                triangles: page.triangles
            });
        }
    }

    componentDidUpdate(prevProps: any) {
        if (this.props.pathname !== prevProps.pathname) {
            this.routePathChange$.next(this.props.pathname);
        }
    }

    onGoToLeft() {
        const page = find(Pages, (item: any) => {
            return item.path === this.props.pathname;
        });

        if (page) {
            navigateTo(page.navigateBack);
        }
    }

    onGoToRight() {
        const page = find(Pages, (item: any) => {
            return item.path === this.props.pathname;
        });

        if (page) {
            navigateTo(page.navigateTo);
        }
    }

    render() {
        return <div className={`mainLayout relative vh100 ${this.state.menuStatus ? 'menuOpened' : ''}`}>
            <BackgroundComponent
                colorMatrix={this.state.colorMatrix || this.defaultColorMatrix}
                triangles={this.state.triangles}/>
            <NavigationComponent/>
            <div className="absolute absolute-full MS overflow-hidden mainLayoutWrapper">
                {this.props.children}

                <span className="hivatalosKozlemenyek pointer MS"
                      onClick={() => this.hkModalRef.openModal()}>{Translation.get('misc.official_announcements.title')}</span>
            </div>
            <div className="navigationArrowLeft" onClick={() => this.onGoToLeft()}>
                <img src={leftArrow} alt=""/>
            </div>

            <div className="navigationArrowRight" onClick={() => this.onGoToRight()}>
                <img src={rightArrow} alt=""/>
            </div>

            <span className="paginationMarker MS">{this.state.index + 1} / {Object.keys(Pages).length}</span>

            <ModalComponent isHK={true} ref={(ref: any) => {
                this.hkModalRef = ref;
            }}>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-6 col-12 d-flex justify-content-center align-items-center'>
                            <img className='w-100' src={logo} alt=""/></div>
                        <div
                            className='col-md-6 col-12 d-flex justify-content-center align-items-start flex-column content-text'>
                            <span>Cég elnevezése: InteliArt Online Marketing Korlátolt Felelőségű Társaság</span>
                            <span>Cég rövid elnevezése: InteliArt Online Marketing Kft.</span>
                            <span>Cégjegyzékszám: 13-09-205891</span>
                            <span>Cég székhelye: 2440 Százhalombatta, Csalogány utca 19.</span>
                            <span>Cég adószáma: 23160277-2-13</span>
                        </div>
                    </div>
                </div>
            </ModalComponent>
        </div>;
    }
}

/**
 * A react-router 7 nem ad route propot az elem-alapú route-oknak, ezért a hookos
 * adatokat (útvonal, navigate) ez a wrapper adja át a class alapú MainLayoutnak.
 */
export function MainLayoutRoute() {
    const location = useLocation();
    const navigate = useNavigate();

    React.useEffect(() => {
        setNavigator(navigate);
    }, [navigate]);

    return <MainLayout pathname={location.pathname}>
        <Outlet/>
    </MainLayout>;
}
